import { render, staticRenderFns } from "./ApplyRole.vue?vue&type=template&id=dc3356c8&scoped=true"
import script from "./ApplyRole.vue?vue&type=script&lang=js"
export * from "./ApplyRole.vue?vue&type=script&lang=js"
import style0 from "./ApplyRole.vue?vue&type=style&index=0&id=dc3356c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3356c8",
  null
  
)

export default component.exports